
        window.addEventListener('DOMContentLoaded', async () => {
            console.log('DOMContentLoaded fired');
            console.log('window.startGame:', window.startGame);
            if (window.startGame) {
                console.log('Calling startGame...');
                await window.startGame();
            } else {
                console.error('startGame not found on window!');
            }
        });
    